import React, { useState } from "react";
import { Container, Row, Col, Card, ListGroup, Button, Badge } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import BookDemo from "./BookDemo";
import "./schoolproduct.scss";
import { useNavigate } from "react-router-dom";

function EcommerceProdHome() {
   const [show, setShow] = useState(false);
    const navigate = useNavigate();
  
    const [selectedProduct, setSelectedProduct] = useState("");
    
      const openDemo = (product) => {
       setSelectedProduct(product);
       setShow(true);
     };
  

  return (
    <section className="school-product-section py-5">
      <Container>

        {/* Section Header */}
        <div className="text-center mb-5">
          <Badge bg="success" className="px-3 py-2 mb-3">
            Our Premium Product
          </Badge>
          <h2 className="fw-bold display-6">
            Uiplus Ecommerce Website Solution
          </h2>
          <p className="text-muted">
            A powerful and scalable ecommerce platform designed to help businesses 
            sell products online, manage orders, and grow digitally.
          </p>
        </div>

        <Row className="align-items-center">

          {/* LEFT IMAGE */}
          <Col md={5} className="mb-4 text-center">
            <img
              src="/images/ecommerce-01.png"
              alt="Uiplus Ecommerce Dashboard"
              className="img-fluid rounded shadow-lg"
            />
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={7}>
            <Card className="border-0 shadow-lg p-2 product-modern-card">
              <Card.Body>

                <h5 className="fw-bold mb-3">
                  Smart Ecommerce Management Made Easy
                </h5>

                <p className="text-muted" style={{ textAlign: "justify" }}>
                  Uiplus Ecommerce solution is an all-in-one platform that helps you 
                  manage products, orders, customers, payments, and inventory from a 
                  single dashboard with ease and efficiency.
                </p>

                <Row className="mt-4">

                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Admin Features</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Product & Category Management
                      </ListGroup.Item>
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Order & Payment Tracking
                      </ListGroup.Item>
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Reports & Sales Analytics
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Customer Features</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Easy Product Search & Filters
                      </ListGroup.Item>
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Secure Checkout & Payments
                      </ListGroup.Item>
                      <ListGroup.Item style={{ padding: "5px" }}>
                        <CheckCircleFill className="text-success me-2" />
                        Order Tracking & Notifications
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                </Row>

                {/* Highlight Box */}
                <div className="mt-4 p-3 rounded bg-light border-start border-4 border-success">
                  <strong>Why Choose Uiplus Ecommerce?</strong>
                  <p className="mb-0 mt-2 text-muted" style={{ textAlign: "justify" }}>
                    Fast performance, mobile-friendly design, SEO optimized structure,
                    secure payment integration, and scalable architecture to grow your
                    online business.
                  </p>
                </div>

                {/* CTA Buttons */}
                <div className="mt-4 d-flex flex-wrap gap-3">
                  <Button variant="success" onClick={() => openDemo("Ecommerce Website")}>
                    Book Demo
                  </Button>

                  <Button
                    variant="outline-success"
                    onClick={() => navigate("/products/ecommerce-website")}
                  >
                    View Details
                  </Button>
                </div>

              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>

      {/* <BookDemo show={showDemo} handleClose={() => setShowDemo(false)} /> */}
        <BookDemo
          show={show}
          handleClose={() => setShow(false)}
          productName={selectedProduct}
        />
    </section>
  );
}

export default EcommerceProdHome;